import { styled } from 'styled-components';

export const RedirectInfotext = styled.div`
    margin: 3em 1em 1em 1em;
    font-size: 1.5rem;
    justify-content: center;
    display: flex;
`;
